import React, { Component } from 'react';
import {
  getBusinessSetupData,
  updateBusinessOwner,
  saveLocation,
  saveBusiness,
  updateBusinessCategories,
  updateBusinessWorkingHours,
  updateBusinessProfileCompleted,
  getComplexesAndCitiesLookup,
  getCategoriesMasterLookup,
} from '../../services/myBusinessesService';

class BusinessWizardForm extends Component {
  constructor(props) {
    super(props);

    const ownerFromProps = props.owner || null;

    const initialOwner = {
      id: ownerFromProps ? ownerFromProps.id : '',
      name: ownerFromProps ? ownerFromProps.name || '' : '',
      phone_number: ownerFromProps ? ownerFromProps.phone_number || '' : '',
    };

    this.state = {
      loading: props.mode === 'edit',
      saving: false,
      errorMessage: '',
      successMessage: '',
      step: 1,

      lookupsLoaded: false,
      categoriesLoaded: false,

      lookups: {
        complexes: [],
        cities: [],
      },

      categoriesMaster: [],
      subcategoriesByCategory: {},

      complexSearch: '',
      citySearch: '',
      showComplexDropdown: false,
      showCityDropdown: false,

      originalOwner: initialOwner,
      owner: initialOwner,

      location: {
        location_id: '',
        complex_id: '',
        city_id: '',
        name: '',
        code: '',
        zip_code: '',
        floor: '',
        unit_number: '',
        address: '',
        latitude: '',
        longitude: '',
        description: '',
      },

      business: {
        business_id: '',
        name: '',
        description: '',
        phone_number: '',
        phone: '',
        location_id: '',
      },

      categories: {
        selectedCategoryIds: [],
      },

      working_hours: [
  { day_of_week: 0, day_name: 'Sunday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
  { day_of_week: 1, day_name: 'Monday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
  { day_of_week: 2, day_name: 'Tuesday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
  { day_of_week: 3, day_name: 'Wednesday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
  { day_of_week: 4, day_name: 'Thursday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
  { day_of_week: 5, day_name: 'Friday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
  { day_of_week: 6, day_name: 'Saturday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
],
    };
  }

  componentDidMount() {
    const { mode, businessItem } = this.props;

    if (mode === 'edit' && businessItem && businessItem.id) {
      this.loadEditData(businessItem.id);
      return;
    }

    this.setState({
      loading: false,
    });
  }

  isCrossingMidnight = (item) => {
  if (!item.is_open || !item.open_time || !item.close_time) {
    return false;
  }

  return item.close_time <= item.open_time;
};

  loadEditData = (businessId) => {
    getBusinessSetupData(businessId)
      .then((response) => {
        const data = response.data || {};
        const categoriesSelected = (data.categories && data.categories.selected) || [];
        const categoriesWithSubcategories =
          (data.categories && data.categories.with_subcategories) || [];

        const ownerData = {
          id: data.owner ? data.owner.id : '',
          name: data.owner ? data.owner.name || '' : '',
          phone_number: data.owner ? data.owner.phone_number || '' : '',
        };

        this.setState({
          loading: false,
          lookupsLoaded: true,
          categoriesLoaded: true,
          originalOwner: ownerData,
          owner: ownerData,
          complexSearch: data.location ? data.location.complex_name || '' : '',
          citySearch: data.location ? data.location.city_name || '' : '',
          lookups: {
            complexes: (data.lookups && data.lookups.complexes) || [],
            cities: (data.lookups && data.lookups.cities) || [],
          },
          location: {
            location_id: data.location ? data.location.id : '',
            complex_id: data.location ? data.location.complex_id : '',
            city_id: data.location ? data.location.city_id : '',
            name: data.location ? data.location.name || '' : '',
            code: data.location ? data.location.code || '' : '',
            zip_code: data.location ? data.location.zip_code || '' : '',
            floor: data.location ? data.location.floor || '' : '',
            unit_number: data.location ? data.location.unit_number || '' : '',
            address: data.location ? data.location.address || '' : '',
            latitude: data.location ? data.location.latitude || '' : '',
            longitude: data.location ? data.location.longitude || '' : '',
            description: data.location ? data.location.description || '' : '',
          },
          business: {
            business_id: data.business ? data.business.id : '',
            name: data.business ? data.business.name || '' : '',
            description: data.business ? data.business.description || '' : '',
            phone_number: data.business ? data.business.phone_number || '' : '',
            phone: data.business ? data.business.phone || '' : '',
            location_id: data.business ? data.business.location_id || '' : '',
          },
          categoriesMaster: categoriesWithSubcategories,
          subcategoriesByCategory: this.buildSubcategoriesMap(categoriesWithSubcategories),
          categories: {
            selectedCategoryIds: categoriesSelected.map((item) => item.category_id),
          },
          working_hours: this.normalizeWorkingHours(data.working_hours || []),
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error.message || 'שגיאה בטעינת נתוני העסק',
        });
      });
  };

  buildSubcategoriesMap = (categoriesWithSubcategories) => {
    const result = {};

    categoriesWithSubcategories.forEach((category) => {
      result[category.id] = category.subcategories || [];
    });

    return result;
  };

  normalizeWorkingHours = (serverHours) => {
  const defaultDays = [
    { day_of_week: 0, day_name: 'Sunday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
    { day_of_week: 1, day_name: 'Monday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
    { day_of_week: 2, day_name: 'Tuesday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
    { day_of_week: 3, day_name: 'Wednesday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
    { day_of_week: 4, day_name: 'Thursday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
    { day_of_week: 5, day_name: 'Friday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
    { day_of_week: 6, day_name: 'Saturday', is_open: false, open_time: '', close_time: '', closes_next_day: false, notes: '' },
  ];

  return defaultDays.map((day) => {
    const found = serverHours.find((item) => item.day_of_week === day.day_of_week);

    if (!found) {
      return day;
    }

    return {
      day_of_week: found.day_of_week,
      day_name: found.day_name || day.day_name,
      is_open: !!found.is_open,
      open_time: found.open_time ? found.open_time.substring(0, 5) : '',
      close_time: found.close_time ? found.close_time.substring(0, 5) : '',
      closes_next_day: !!found.closes_next_day,
      notes: found.notes || '',
    };
  });
};

  buildSubcategoriesMapFromUpdateResponse = (responseData) => {
    const result = {};
    const subcategoriesByCategory =
      responseData.subcategories_by_category ||
      (responseData.data && responseData.data.subcategories_by_category) ||
      {};

    Object.keys(subcategoriesByCategory).forEach((key) => {
      result[key] = subcategoriesByCategory[key] || [];
    });

    return result;
  };

  loadStep2LookupsIfNeeded = () => {
    if (this.state.lookupsLoaded) {
      return Promise.resolve();
    }

    return getComplexesAndCitiesLookup().then((response) => {
      this.setState({
        lookupsLoaded: true,
        lookups: {
          complexes: response.complexes || [],
          cities: response.cities || [],
        },
      });
    });
  };

  loadStep4CategoriesIfNeeded = () => {
    if (this.state.categoriesLoaded) {
      return Promise.resolve();
    }

    return getCategoriesMasterLookup().then((response) => {
      const categories = response.categories || [];

      this.setState({
        categoriesLoaded: true,
        categoriesMaster: categories,
        subcategoriesByCategory: {},
      });
    });
  };

  moveToStep = (nextStep) => {
    this.setState({
      loading: true,
      errorMessage: '',
      successMessage: '',
    });

    let loader = Promise.resolve();

    if (nextStep === 2) {
      loader = this.loadStep2LookupsIfNeeded();
    }

    if (nextStep === 4) {
      loader = this.loadStep4CategoriesIfNeeded();
    }

    loader
      .then(() => {
        this.setState({
          loading: false,
          step: nextStep,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error.message || 'שגיאה בטעינת נתוני השלב',
        });
      });
  };

  handleOwnerChange = (field, value) => {
    this.setState((prevState) => ({
      owner: {
        ...prevState.owner,
        [field]: value,
      },
    }));
  };

  handleLocationChange = (field, value) => {
    this.setState((prevState) => ({
      location: {
        ...prevState.location,
        [field]: value,
      },
    }));
  };

  handleBusinessChange = (field, value) => {
    this.setState((prevState) => ({
      business: {
        ...prevState.business,
        [field]: value,
      },
    }));
  };

  handleCategoryToggle = (categoryId) => {
    this.setState((prevState) => {
      const exists = prevState.categories.selectedCategoryIds.includes(categoryId);

      return {
        categories: {
          ...prevState.categories,
          selectedCategoryIds: exists
            ? prevState.categories.selectedCategoryIds.filter((id) => id !== categoryId)
            : [...prevState.categories.selectedCategoryIds, categoryId],
        },
      };
    });
  };



  handleWorkingHourChange = (dayOfWeek, field, value) => {
    this.setState((prevState) => ({
      working_hours: prevState.working_hours.map((item) => {
        if (item.day_of_week !== dayOfWeek) {
          return item;
        }

        return {
          ...item,
          [field]: value,
        };
      }),
    }));
  };

  handleComplexSearchChange = (value) => {
    this.setState((prevState) => ({
      complexSearch: value,
      showComplexDropdown: true,
      location: {
        ...prevState.location,
        complex_id: '',
      },
    }));
  };

  handleCitySearchChange = (value) => {
    this.setState((prevState) => ({
      citySearch: value,
      showCityDropdown: true,
      location: {
        ...prevState.location,
        city_id: '',
      },
    }));
  };

  selectComplex = (item) => {
    this.setState((prevState) => ({
      complexSearch: item.name,
      showComplexDropdown: false,
      location: {
        ...prevState.location,
        complex_id: item.id,
      },
    }));
  };

  selectCity = (item) => {
    this.setState((prevState) => ({
      citySearch: item.name,
      showCityDropdown: false,
      location: {
        ...prevState.location,
        city_id: item.id,
      },
    }));
  };

  getFilteredComplexes = () => {
    const { lookups, complexSearch } = this.state;

    if (!complexSearch.trim()) {
      return lookups.complexes;
    }

    return lookups.complexes.filter((item) =>
      (item.name || '').toLowerCase().includes(complexSearch.toLowerCase())
    );
  };

  getFilteredCities = () => {
    const { lookups, citySearch } = this.state;

    if (!citySearch.trim()) {
      return lookups.cities;
    }

    return lookups.cities.filter((item) =>
      (item.name || '').toLowerCase().includes(citySearch.toLowerCase())
    );
  };

  getSelectedCategoriesSubcategories = () => {
    const { categories, subcategoriesByCategory } = this.state;
    const all = [];

    categories.selectedCategoryIds.forEach((categoryId) => {
      const list = subcategoriesByCategory[categoryId] || [];
      list.forEach((item) => all.push(item));
    });

    return all;
  };

  goBack = () => {
    this.setState((prevState) => ({
      step: Math.max(1, prevState.step - 1),
      errorMessage: '',
      successMessage: '',
    }));
  };

  handleNext = () => {
    const { step } = this.state;

    if (step === 1) {
      this.saveStep1Owner();
      return;
    }

    if (step === 2) {
      this.saveStep2Location();
      return;
    }

    if (step === 3) {
      this.saveStep3Business();
      return;
    }

    if (step === 4) {
      this.saveStep4Categories();
      return;
    }
  };

  handleFinish = () => {
    this.saveStep5WorkingHoursAndComplete();
  };

  saveStep1Owner = () => {
    const { owner, originalOwner } = this.state;

    const sameName = (owner.name || '').trim() === (originalOwner.name || '').trim();
    const samePhone = (owner.phone_number || '').trim() === (originalOwner.phone_number || '').trim();

    if (sameName && samePhone) {
      this.moveToStep(2);
      return;
    }

    this.setState({
      saving: true,
      errorMessage: '',
      successMessage: '',
    });

    updateBusinessOwner({
      name: owner.name,
      phone_number: owner.phone_number,
    })
      .then(() => {
        this.setState(
          (prevState) => ({
            saving: false,
            originalOwner: {
              ...prevState.owner,
            },
          }),
          () => {
            this.moveToStep(2);
          }
        );
      })
      .catch((error) => {
        this.setState({
          saving: false,
          errorMessage: error.message || 'שגיאה בשמירת בעל העסק',
        });
      });
  };

  saveStep2Location = () => {
    const { location } = this.state;

    const payload = {
      complex_id: location.complex_id,
      city_id: location.city_id,
      name: location.name,
      code: location.code,
      zip_code: location.zip_code,
      floor: location.floor,
      unit_number: location.unit_number,
      address: location.address,
      latitude: location.latitude,
      longitude: location.longitude,
      description: location.description,
    };

    if (location.location_id) {
      payload.location_id = location.location_id;
    }

    this.setState({
      saving: true,
      errorMessage: '',
      successMessage: '',
    });

    saveLocation(payload)
      .then((response) => {
        const locationId =
          response.location_id ||
          (response.data && response.data.location_id) ||
          (response.data && response.data.id) ||
          location.location_id;

        this.setState(
          (prevState) => ({
            saving: false,
            location: {
              ...prevState.location,
              location_id: locationId,
            },
            business: {
              ...prevState.business,
              location_id: locationId,
            },
          }),
          () => {
            this.moveToStep(3);
          }
        );
      })
      .catch((error) => {
        this.setState({
          saving: false,
          errorMessage: error.message || 'שגיאה בשמירת המיקום',
        });
      });
  };

  saveStep3Business = () => {
    const { business } = this.state;

    const payload = {
      name: business.name,
      description: business.description,
      phone_number: business.phone_number,
      phone: business.phone,
      location_id: business.location_id,
    };

    if (business.business_id) {
      payload.business_id = business.business_id;
    }

    this.setState({
      saving: true,
      errorMessage: '',
      successMessage: '',
    });

    saveBusiness(payload)
      .then((response) => {
        const businessId =
          response.business_id ||
          (response.data && response.data.business_id) ||
          (response.data && response.data.id) ||
          business.business_id;

        this.setState(
          (prevState) => ({
            saving: false,
            business: {
              ...prevState.business,
              business_id: businessId,
            },
          }),
          () => {
            this.moveToStep(4);
          }
        );
      })
      .catch((error) => {
        this.setState({
          saving: false,
          errorMessage: error.message || 'שגיאה בשמירת העסק',
        });
      });
  };

  saveStep4Categories = () => {
    const { business, categories } = this.state;

    this.setState({
      saving: true,
      errorMessage: '',
      successMessage: '',
    });

    updateBusinessCategories({
      business_id: business.business_id,
      category_ids: categories.selectedCategoryIds,
    })
      .then((response) => {
        this.setState(
          {
            saving: false,
            subcategoriesByCategory: this.buildSubcategoriesMapFromUpdateResponse(response),
          },
          () => {
            this.moveToStep(5);
          }
        );
      })
      .catch((error) => {
        this.setState({
          saving: false,
          errorMessage: error.message || 'שגיאה בשמירת הקטגוריות',
        });
      });
  };

  saveStep5WorkingHoursAndComplete = () => {
    const { business, working_hours } = this.state;

    const invalidOpenDay = working_hours.find(
      (item) => item.is_open && (!item.open_time || !item.close_time)
    );

    if (invalidOpenDay) {
      this.setState({
        errorMessage: 'יש להזין שעת פתיחה ושעת סגירה לכל יום עבודה פתוח',
        successMessage: '',
      });
      return;
    }



    const invalidCrossDay = working_hours.find(
  (item) =>
    item.is_open &&
    item.open_time &&
    item.close_time &&
    item.close_time <= item.open_time &&
    !item.closes_next_day
);

if (invalidCrossDay) {
  this.setState({
    errorMessage: 'יש ימים שבהם שעת הסגירה מוקדמת או שווה לשעת הפתיחה. סמן "נסגר ביום הבא" עבורם.',
    successMessage: '',
  });
  return;
}

    this.setState({
      saving: true,
      errorMessage: '',
      successMessage: '',
    });

    updateBusinessWorkingHours({
      business_id: business.business_id,
      working_hours: working_hours.map((item) => ({
        day_of_week: item.day_of_week,
        is_open: item.is_open,
        open_time: item.is_open ? item.open_time : null,
        close_time: item.is_open ? item.close_time : null,
        notes: item.notes ? item.notes : null,
        closes_next_day: item.is_open ? !!item.closes_next_day : false,
      })),
    })
      .then(() => {
        return updateBusinessProfileCompleted({
          business_id: business.business_id,
          profile_completed: true,
        });
      })
      .then(() => {
        this.setState({
          saving: false,
          successMessage: 'העסק נשמר והושלם בהצלחה',
        });

        if (this.props.onSaved) {
          this.props.onSaved();
        }

        if (this.props.onClose) {
          this.props.onClose();
        }
      })
      .catch((error) => {
        this.setState({
          saving: false,
          errorMessage: error.message || 'שגיאה בשמירת שעות הפעילות',
        });
      });
  };

  renderStepIndicator = () => {
    const { step } = this.state;
    const steps = ['בעל עסק', 'מיקום', 'עסק', 'קטגוריות', 'שעות פעילות'];

    return (
      <div className="wizard-steps">
        {steps.map((item, index) => (
          <div
            key={index}
            className={step === index + 1 ? 'wizard-step active' : 'wizard-step'}
          >
            <span className="wizard-step-number">{index + 1}</span>
            <span className="wizard-step-text">{item}</span>
          </div>
        ))}
      </div>
    );
  };

  renderStep1 = () => {
    const { owner } = this.state;

    return (
      <div className="wizard-form-grid">
        <div className="form-group">
          <label>שם בעל העסק</label>
          <input
            type="text"
            value={owner.name}
            onChange={(e) => this.handleOwnerChange('name', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>מספר טלפון</label>
          <input
            type="text"
            value={owner.phone_number}
            readOnly
            className="readonly-input"
            dir="ltr"
          />
        </div>
      </div>
    );
  };

  renderStep2 = () => {
    const {
      location,
      complexSearch,
      citySearch,
      showComplexDropdown,
      showCityDropdown,
    } = this.state;

    const filteredComplexes = this.getFilteredComplexes();
    const filteredCities = this.getFilteredCities();

    return (
      <div className="wizard-form-grid">
        <div className="form-group autocomplete-group">
          <label>מתחם</label>
          <input
            type="text"
            value={complexSearch}
            placeholder="חפש ובחר מתחם"
            onChange={(e) => this.handleComplexSearchChange(e.target.value)}
            onFocus={() => this.setState({ showComplexDropdown: true })}
          />
          {showComplexDropdown && (
            <div className="autocomplete-dropdown">
              {filteredComplexes.length === 0 ? (
                <div className="autocomplete-empty">אין תוצאות</div>
              ) : (
                filteredComplexes.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    className="autocomplete-item"
                    onClick={() => this.selectComplex(item)}
                  >
                    {item.name}
                  </button>
                ))
              )}
            </div>
          )}
        </div>

        <div className="form-group autocomplete-group">
          <label>עיר</label>
          <input
            type="text"
            value={citySearch}
            placeholder="חפש ובחר עיר"
            onChange={(e) => this.handleCitySearchChange(e.target.value)}
            onFocus={() => this.setState({ showCityDropdown: true })}
          />
          {showCityDropdown && (
            <div className="autocomplete-dropdown">
              {filteredCities.length === 0 ? (
                <div className="autocomplete-empty">אין תוצאות</div>
              ) : (
                filteredCities.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    className="autocomplete-item"
                    onClick={() => this.selectCity(item)}
                  >
                    {item.name}
                  </button>
                ))
              )}
            </div>
          )}
        </div>

        <div className="form-group">
          <label>שם מיקום</label>
          <input
            type="text"
            value={location.name}
            onChange={(e) => this.handleLocationChange('name', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>קוד</label>
          <input
            type="text"
            value={location.code}
            onChange={(e) => this.handleLocationChange('code', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>מיקוד</label>
          <input
            type="text"
            value={location.zip_code}
            onChange={(e) => this.handleLocationChange('zip_code', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>קומה</label>
          <input
            type="text"
            value={location.floor}
            onChange={(e) => this.handleLocationChange('floor', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>מספר יחידה</label>
          <input
            type="text"
            value={location.unit_number}
            onChange={(e) => this.handleLocationChange('unit_number', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>כתובת</label>
          <input
            type="text"
            value={location.address}
            onChange={(e) => this.handleLocationChange('address', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Latitude</label>
          <input
            type="text"
            value={location.latitude}
            onChange={(e) => this.handleLocationChange('latitude', e.target.value)}
            dir="ltr"
          />
        </div>

        <div className="form-group">
          <label>Longitude</label>
          <input
            type="text"
            value={location.longitude}
            onChange={(e) => this.handleLocationChange('longitude', e.target.value)}
            dir="ltr"
          />
        </div>

        <div className="form-group full-width">
          <label>תיאור</label>
          <textarea
            value={location.description}
            onChange={(e) => this.handleLocationChange('description', e.target.value)}
          />
        </div>
      </div>
    );
  };

  renderStep3 = () => {
    const { business } = this.state;

    return (
      <div className="wizard-form-grid">
        <div className="form-group">
          <label>שם העסק</label>
          <input
            type="text"
            value={business.name}
            onChange={(e) => this.handleBusinessChange('name', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>טלפון נייד</label>
          <input
            type="text"
            value={business.phone_number}
            onChange={(e) => this.handleBusinessChange('phone_number', e.target.value)}
            dir="ltr"
          />
        </div>

        <div className="form-group">
          <label>טלפון קווי</label>
          <input
            type="text"
            value={business.phone}
            onChange={(e) => this.handleBusinessChange('phone', e.target.value)}
            dir="ltr"
          />
        </div>

        <div className="form-group full-width">
          <label>תיאור העסק</label>
          <textarea
            value={business.description}
            onChange={(e) => this.handleBusinessChange('description', e.target.value)}
          />
        </div>
      </div>
    );
  };

  renderStep4 = () => {
  const { categoriesMaster, categories, subcategoriesByCategory } = this.state;
  const selectedSubcategories = this.getSelectedCategoriesSubcategories();

  return (
    <div className="wizard-categories-layout">
      <div className="wizard-categories-column">
        <div className="wizard-column-title">קטגוריות</div>

        {categoriesMaster.map((category) => (
          <label key={category.id} className="wizard-checkbox-item">
            <input
              type="checkbox"
              checked={categories.selectedCategoryIds.includes(category.id)}
              onChange={() => this.handleCategoryToggle(category.id)}
            />
            <span>{category.name}</span>
          </label>
        ))}
      </div>

      <div className="wizard-categories-column">
        <div className="wizard-column-title">תתי קטגוריות של הקטגוריות שנבחרו</div>

        {categories.selectedCategoryIds.length === 0 ? (
          <div className="autocomplete-empty">בחר קטגוריה כדי לראות את תתי הקטגוריות שלה</div>
        ) : selectedSubcategories.length === 0 ? (
          <div className="autocomplete-empty">
            תתי הקטגוריות יוצגו לאחר שמירת הקטגוריות וטעינת הנתונים מהשרת
          </div>
        ) : (
          selectedSubcategories.map((sub) => (
            <div key={sub.id} className="wizard-subcategory-display-item">
              {sub.name}
            </div>
          ))
        )}

        {Object.keys(subcategoriesByCategory).length > 0 &&
        categories.selectedCategoryIds.length > 0 &&
        selectedSubcategories.length === 0 ? (
          <div className="autocomplete-empty">לא נמצאו תתי קטגוריות</div>
        ) : null}
      </div>
    </div>
  );
};

  renderStep5 = () => {
  const { working_hours } = this.state;

  return (
    <div className="working-hours-list">
      {working_hours.map((item) => {
        const crossingMidnight = this.isCrossingMidnight(item);

        return (
          <div className="working-hour-row" key={item.day_of_week}>
            <div className="working-day-name">{item.day_name}</div>

            <div className="working-day-open">
              <label className="wizard-switch-line">
                <input
                  type="checkbox"
                  checked={item.is_open}
                  onChange={(e) =>
                    this.handleWorkingHourChange(item.day_of_week, 'is_open', e.target.checked)
                  }
                />
                <span>עובד</span>
              </label>
            </div>

            <div className="working-day-times">
              <input
                type="time"
                value={item.open_time}
                disabled={!item.is_open}
                onChange={(e) =>
                  this.handleWorkingHourChange(item.day_of_week, 'open_time', e.target.value)
                }
              />
              <input
                type="time"
                value={item.close_time}
                disabled={!item.is_open}
                onChange={(e) =>
                  this.handleWorkingHourChange(item.day_of_week, 'close_time', e.target.value)
                }
              />
            </div>

            <div className="working-day-notes">
              <input
                type="text"
                value={item.notes}
                placeholder="הערה"
                onChange={(e) =>
                  this.handleWorkingHourChange(item.day_of_week, 'notes', e.target.value)
                }
              />
            </div>

            {crossingMidnight && (
              <div className="working-hour-next-day-box">
                <div className="working-hour-warning">
                  שעת הסגירה מוקדמת או שווה לשעת הפתיחה. אם העסק נסגר ביום הבא, הפעל את האפשרות:
                </div>

                <label className="wizard-switch-line">
                  <input
                    type="checkbox"
                    checked={!!item.closes_next_day}
                    onChange={(e) =>
                      this.handleWorkingHourChange(
                        item.day_of_week,
                        'closes_next_day',
                        e.target.checked
                      )
                    }
                  />
                  <span>נסגר ביום הבא</span>
                </label>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

  renderCurrentStep = () => {
    const { step } = this.state;

    if (step === 1) return this.renderStep1();
    if (step === 2) return this.renderStep2();
    if (step === 3) return this.renderStep3();
    if (step === 4) return this.renderStep4();
    return this.renderStep5();
  };

  renderActions = () => {
    const { step, saving } = this.state;

    return (
      <div className="wizard-actions">
        {step > 1 && (
          <button type="button" className="wizard-secondary-btn" onClick={this.goBack} disabled={saving}>
            חזור
          </button>
        )}

        {step < 5 && (
          <button type="button" className="wizard-primary-btn" onClick={this.handleNext} disabled={saving}>
            {saving ? 'שומר...' : 'המשך'}
          </button>
        )}

        {step === 5 && (
          <button type="button" className="wizard-primary-btn" onClick={this.handleFinish} disabled={saving}>
            {saving ? 'שומר...' : 'סיום'}
          </button>
        )}
      </div>
    );
  };

  render() {
    const { loading, errorMessage, successMessage } = this.state;

    if (loading) {
      return <div className="wizard-loading">טוען נתונים...</div>;
    }

    return (
      <div className="business-wizard-form">
        {this.renderStepIndicator()}

        {errorMessage && <div className="message-box error-box">{errorMessage}</div>}
        {successMessage && <div className="message-box success-box">{successMessage}</div>}

        <div className="wizard-step-content">{this.renderCurrentStep()}</div>

        {this.renderActions()}
      </div>
    );
  }
}

export default BusinessWizardForm;